export default "__VITE_ASSET__540e54fc__"